import PropTypes from 'prop-types'
import React from 'react'
import { skin } from 'Utils'
import skins from '../skins'

const Loading = props => {
  return (
    <div className={`${props.className} modal--loading`}>
      <div className="card--loading"></div>
      <div className="card--loading"></div>
      <div className="card--loading"></div>
      <div className="card--loading"></div>
    </div>
  )
}

Loading.propTypes = {
  className: PropTypes.any
}

export default skin(Loading, skins)
